export default "__VITE_PUBLIC_ASSET__c794c6b3__"